import type Geometry from 'ol/geom/Geometry'
import type Feature from 'ol/Feature'

type PlaceFeatureMetadata = {
  mode: 'on' | 'off' | 'label'
  type: 'place'
  hasViolations: boolean
  ordersCount: number
  ordersWithViolationsCount: number
}

export const setPlaceFeatureMetadata = <Field extends keyof PlaceFeatureMetadata>(
  target: Feature<Geometry>,
  field: Field,
  value: PlaceFeatureMetadata[Field],
) => {
  target.set(field, value)
}

export const getPlaceFeatureMetadata = <Field extends keyof PlaceFeatureMetadata>(
  target: Feature<Geometry>,
  field: Field,
): PlaceFeatureMetadata[Field] | undefined => {
  return target.get(field)
}

export const removePlaceFeatureMetadata = <Field extends keyof PlaceFeatureMetadata>(
  target: Feature<Geometry>,
  field: Field,
) => {
  target.unset(field)
}
